export const mergeAndSave = (key, newData) => {
  const saved = localStorage.getItem(key);
  let existing = [];
  try {
    existing = saved ? JSON.parse(saved) : [];
  } catch (e) {
    existing = [];
  }

  // Create a map for existing items
  const itemMap = new Map(existing.map((item) => [item.id, item]));

  // Update or add new items
  newData.forEach((item) => {
    itemMap.set(item.id, item);
  });

  const merged = Array.from(itemMap.values());
  localStorage.setItem(key, JSON.stringify(merged));
  return merged;
};
